<shopping-cart addedProduct="{{addedProduct}}"></shopping-cart>
<div class="breadcrumb-container">
  <div class="breadcrumb">
    <a href="">
      <i class="icon icon-home"></i>
    </a>
    <span class="arrow">&#8250;</span>
    <span>Producten</span>
  </div>
  <span>{{ activeProducts?.length }} producten</span>
</div>
<div class="main-content">
  <div class="filter-container">
    <div class="search-wrapper">
      <div class="search-input-wrapper">
        <input type="text" placeholder="Waar ben je naar op zoek?" [(ngModel)]="filterInput" (ngModelChange)="filterProducts()"/>
      </div>
      <div class="filter-button-wrapper" (click)="openFilterPanel()">
        <i class="icon icon-tune"></i>
      </div>
    </div>

    <div class="filter-panel">
      <div class="mobile-logo">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="1833.000000pt" height="55.000000pt" viewBox="0 0 1833.000000 220.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,220.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M10 2178 c5 -13 192 -480 415 -1038 472 -1182 455 -1140 465 -1140 4 0 157 375 340 832 183 458 376 943 430 1078 54 135 101 255 105 268 l6 22 -134 0 c-98 0 -137 -4 -145 -13 -6 -7 -24 -49 -40 -92 -17 -44 -89 -233 -162 -420 -73 -187 -181 -468 -240 -625 -59 -157 -120 -312 -135 -345 l-27 -60 -20 45 c-22 50 -111 280 -349 900 -88 228 -176 458 -197 510 l-38 95 -142 3 -142 3 10 -23z" /> <path d="M3175 2188 c-3 -7 -4 -474 -3 -1038 l3 -1025 128 -3 127 -3 -2 1038 -3 1038 -123 3 c-92 2 -124 -1 -127 -10z" /> <path d="M4844 2187 c-2 -7 -3 -58 -2 -113 l3 -99 260 -5 260 -5 5 -920 5 -920 122 -3 123 -3 2 923 3 923 258 3 258 2 -3 113 -3 112 -643 3 c-527 2 -643 0 -648 -11z" /> <path d="M7566 2184 c-8 -20 -8 -2027 0 -2048 6 -14 65 -16 570 -16 l565 0 -3 113 -3 112 -438 3 -437 2 2 393 3 392 419 3 c321 2 422 5 428 15 14 22 9 193 -5 206 -10 7 -142 12 -428 13 l-414 3 0 295 0 295 435 5 435 5 0 110 0 110 -561 3 c-506 2 -562 1 -568 -14z" /> <path d="M10236 2184 c-8 -20 -8 -2028 0 -2048 6 -14 65 -16 570 -16 l564 0 0 115 0 115 -440 0 -440 0 2 393 3 392 419 3 c321 2 422 5 428 15 14 22 9 193 -5 206 -10 7 -142 12 -428 13 l-414 3 0 295 0 295 438 3 437 2 0 115 0 115 -564 0 c-505 0 -564 -2 -570 -16z" /> <path d="M12864 2187 c-2 -7 -3 -58 -2 -113 l3 -99 507 -5 507 -5 -81 -125 c-70 -107 -395 -618 -646 -1015 -42 -66 -156 -245 -254 -398 -98 -152 -181 -284 -184 -292 -6 -13 85 -15 772 -13 l779 3 3 104 c2 77 -1 107 -10 113 -7 4 -262 8 -567 8 -484 0 -552 2 -547 15 3 8 97 158 209 332 112 175 275 431 362 568 180 284 482 759 543 854 23 35 39 67 36 72 -3 5 -321 9 -715 9 -579 0 -711 -2 -715 -13z" /> <path d="M15515 2189 c-7 -11 19 -56 290 -504 100 -165 233 -385 296 -490 l114 -190 -3 -334 c-2 -184 -1 -383 3 -443 l7 -108 119 0 118 0 3 448 3 447 106 170 c59 94 198 321 310 505 111 184 224 371 251 414 26 44 48 83 48 88 0 5 -64 7 -142 6 l-143 -3 -43 -65 c-23 -36 -141 -229 -261 -430 -121 -201 -227 -375 -238 -388 l-18 -22 -125 208 c-68 114 -187 313 -263 442 -77 129 -146 241 -155 248 -20 15 -268 17 -277 1z" /> <path d="M17765 918 c-3 -7 -6 -71 -7 -143 l-3 -130 -150 -5 -150 -5 0 -110 0 -110 150 -5 150 -5 3 -143 3 -143 127 3 127 3 3 143 3 142 149 0 149 0 3 98 c2 53 1 105 -1 114 -3 15 -20 18 -150 20 l-146 3 -5 140 -5 140 -123 3 c-92 2 -124 -1 -127 -10z" /> </g> </svg>
        <span class="close-navigation" (click)="hideFilterPanel()">
          <i class="icon icon-close"></i>
        </span>
      </div>
      <div class="filter-header">
        <div class="breadcrumb">
          <span>Filters</span>
        </div>
        <span (click)="resetFilter()">Filters resetten</span>
      </div>
      <mat-expansion-panel [expanded]="sortPanelOpen" (opened)="sortPanelOpen = true" (closed)="sortPanelOpen = false">
        <mat-expansion-panel-header>
          <mat-panel-title>Sorteren</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container">
          <mat-radio-group [(ngModel)]="sortInput" (ngModelChange)="sortProducts()">
            <mat-radio-button *ngFor="let sort of sortValues" [value]="sort.value">{{ sort.title }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="tagPanelOpen" (opened)="tagPanelOpen = true" (closed)="tagPanelOpen = false">
        <mat-expansion-panel-header>
          <mat-panel-title>Gezondheidsdoel</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container">
          <div *ngFor="let filter of filterTags" class="mat-checkbox-wrapper">
            <mat-checkbox [(ngModel)]="filter.selected" (change)="filterProductsByTag()">{{ filter.tags }}</mat-checkbox>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="categoryPanelOpen" (opened)="categoryPanelOpen = true" (closed)="categoryPanelOpen = false">
        <mat-expansion-panel-header>
          <mat-panel-title>Categorie</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container">
          <div *ngFor="let filter of filterCategories" class="mat-checkbox-wrapper">
            <mat-checkbox [(ngModel)]="filter.selected" (change)="filterProductsByCategory()">{{ filter.category }}</mat-checkbox>
          </div>
        </div>
      </mat-expansion-panel>
      <button class="submit-button square" (click)="foldFilters()">Filteren</button>
    </div>
  </div>

  <div class="product-display">
    <div class="product-display--item" *ngFor="let product of activeProducts">
      <div class="product-display--item-header" (click)="visitProductPage(product)">
        <div class="product-display--item-image">
          <img [src]="product.content?.productImage.data?.attributes.url">
        </div>
        <h2>{{ product.content?.title }}</h2>
        <em>30 capsules</em>
        <p *ngIf="product.content && product.content.checks.length > 0">{{ product.content.checks[0].text }}</p>
      </div>
      <hr>
      <div class="product-display--item-footer" (click)="addProduct(product)">
        <span>Vanaf <b>&euro; {{product.price}}</b></span>
        <button class="add-to-checkout">
          <i class="icon icon-cart"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div>
  <div class="visual-cta">
    <div class="visual-cta--section">
      <span>Niet gevonden wat je zocht?</span>
    </div>
    <div class="visual-cta--section">
      <p>Wij weten dat iedereen uniek is. Maak de Viteezy quiz om de juiste vitaminen, mineralen en meer te vinden.
        Gepersonaliseerd voor jouw gezondheidsdoelen.</p>
    </div>
    <div class="visual-cta--section">
      <a href="/quiz-v2" class="button submit-button--3 submit-button--small">Start de test <i
          class="icon icon-interface-arrow-right"></i></a>
    </div>
    <svg width="101px" height="107px" viewBox="0 0 101 107" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Home-Mobile" transform="translate(-283.000000, -5230.000000)" fill="#FBB158">
          <g id="Group-9" transform="translate(283.000000, 5230.000000)">
            <g id="Group-3" transform="translate(43.285714, 0.000000)">
              <path
                d="M13.6265783,4.3012103 C-0.831789447,15.9515891 -5.67454888,27.2603785 8.49980745,40.2378685 C15.8345854,46.9519171 22.5955145,56.177738 33.7724576,51.0277327 C41.0548026,47.6743424 54.3144964,35.7288884 56.6419339,28.2124681 C60.114156,17.0054287 47.8244705,12.3699879 40.3309375,7.95112935 C34.4133039,4.46401035 19.5223649,-5.32725 13.6265783,4.3012103"
                id="Fill-1"></path>
            </g>
            <g id="Group-6" transform="translate(0.000000, 38.894410)">
              <path
                d="M23.0600645,19.8269153 C27.6989234,12.362243 28.0828488,6.55829898 19.6797884,2.98873717 C15.332482,1.1415714 10.8437294,-1.91600425 6.64797254,2.13255862 C3.91430776,4.76993274 -0.140002895,12.1786737 0.00288665764,15.8973856 C0.217942652,21.440317 6.45745314,21.5851647 10.5160938,22.3825437 C13.7173971,23.0106948 21.9400414,25.0457322 23.0600645,19.8269153"
                id="Fill-4"></path>
            </g>
            <path
              d="M83.6177971,102.788803 C88.7037898,94.5012645 89.1245787,88.056218 79.9139788,84.0933159 C75.1479608,82.0434882 70.2285303,78.6481854 65.6290747,83.1433957 C62.6338764,86.0725613 58.1892944,94.2968699 58.3456292,98.4244641 C58.5808618,104.579829 65.4216024,104.738639 69.8676455,105.625329 C73.3786023,106.32233 82.3890353,108.582434 83.6177971,102.788803"
              id="Fill-7"></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</div>

<div class="disclaimer-wrapper shop-disclaimer">
  <p>*Deze gezondheidsclaim(s) zijn in afwachting van goedkeuring door de Europese Commissie.</p>
  <p>Niet geschikt voor personen jonger dan 18 jaar. Buiten bereik van kinderen houden. Bij doktersbehandeling,
    zwangerschap of het geven van borstvoeding altijd eerst je arts of apotheker raadplegen voordat je het
    voedingssupplement gebruikt. Stop het gebruik onmiddellijk en raadpleeg een arts als er overgevoeligheidsreacties
    optreden. Een gevarieerde, evenwichtige voeding en een gezonde levensstijl zijn belangrijk. Voedingssupplementen
    zijn geen vervanging van een gevarieerde voeding. Volgens het Europese Voedselagentschap EFSA zijn de
    gezondheidsclaims die wij over dit product vorderen wetenschappelijk bewezen.</p>
</div>
